var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconInfo = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  enableBackground: "new 0 0 512 512",
  height: "512px",
  id: "Layer_1",
  viewBox: "0 0 512 512",
  width: "512px",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M257.338,166.245c16.297,0,29.52-13.223,29.52-29.52c0-16.317-13.223-29.501-29.52-29.501   c-16.298,0-29.52,13.185-29.52,29.501C227.818,153.022,241.04,166.245,257.338,166.245z"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "277.383,205.605 277.383,195.265 277.383,185.925 218.343,185.925 218.343,205.605    238.023,205.605 238.023,372.885 218.343,372.885 218.343,392.565 297.063,392.565 297.063,372.885 277.383,372.885  "
}), /*#__PURE__*/React.createElement("path", {
  d: "M256.108,9.65c-135.857,0-246,110.143-246,246c0,135.877,110.143,246,246,246   c135.857,0,246-110.123,246-246C502.108,119.793,391.966,9.65,256.108,9.65z M256.108,481.97   c-124.797,0-226.32-101.533-226.32-226.32S131.312,29.33,256.108,29.33c124.797,0,226.32,101.533,226.32,226.32   S380.905,481.97,256.108,481.97z"
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_info.54f79cec.svg";
export { ForwardRef as ReactComponent };